import { Observable } from 'rxjs';
import { TpvTerminalNotificationResult } from '@app/domain/models/tpv/terminal-notification.model';
import { NotifyTerminalRequest } from '@app/data/dtos/tpv/terminal-notification.dto';

/**
 * Port del reenvío de notificación/credenciales a una terminal (escritura, §6).
 * `idTerminal` (clave natural string) viaja en la RUTA.
 */
export abstract class TerminalNotificationRepository {
  abstract notify(
    idTerminal: string,
    request: NotifyTerminalRequest,
    idempotencyKey?: string,
  ): Observable<TpvTerminalNotificationResult>;
}
